var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"titleBox flex-row ite-c",style:({
        'background':_vm.backgroundColor+ '!important'
      })},[_c('b',[_vm._v(_vm._s(_vm.topTitle.title))]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.topTitle.subTit!==''),expression:"topTitle.subTit!==''"}]},[_vm._v("-"+_vm._s(_vm.topTitle.subTit))])])}
var staticRenderFns = []

export { render, staticRenderFns }